import { CreateLoaderTable } from "@/components/Loaders";
import { Main } from "@/components/Main";
import { useEffect, useState } from "react";
import { ApiDataProps } from "../Tenants";
import { TypePageActions } from "../Plans";
import { AddBtn } from "@/App/Geofences/Add";
import { TableData } from "@/App/Geofences/Table";
import { getGeofencesData } from "@/Api/geofences";
import { GeofenceProps } from "@/types/geofence";
import { usePermissions } from "@/hooks/usePermissions";
import { If } from "@/components/If";
import { PageHeader } from "@/components/PageHeader";
import { MapPin } from "lucide-react";
import { UnityFilter, useUnityFilter } from "@/components/UnityFilter";

export type TableDataProps = GeofenceProps;

export const PageList = () => {
  const [listData, setListData] = useState({} as ApiDataProps<TableDataProps>);
  const [state, setState] = useState("loading");
  const { hasPermission } = usePermissions();
  const unityFilter = useUnityFilter();

  useEffect(() => {
    if (!unityFilter.ready) return;
    (async () => {
      setState("loading");
      const { data } = await getGeofencesData(1, unityFilter.param, unityFilter.nameParam);
      setListData(data?.response);
      setState("production");
    })();
  }, [unityFilter.ready, unityFilter.param, unityFilter.nameParam]);

  const pageActions: TypePageActions = {
    next: async () => {
      if (listData?.current_page < listData?.last_page) {
        setState("loading");

        const { data } = await getGeofencesData(listData?.current_page + 1, unityFilter.param, unityFilter.nameParam);
        setListData(data.response);
        setState("production");
      }
      return;
    },
    previous: async () => {
      if (listData?.current_page > 1) {
        setState("loading");

        const { data } = await getGeofencesData(listData?.current_page - 1, unityFilter.param, unityFilter.nameParam);
        setListData(data.response);
        setState("production");
      }
      return;
    },
    lastPage: async () => {
      if (listData?.current_page !== listData?.last_page) {
        setState("loading");

        const { data } = await getGeofencesData(listData?.last_page, unityFilter.param, unityFilter.nameParam);
        setListData(data?.response);
        setState("production");
      }
      return;
    },
  };

  return (
    <Main>
      <If condition={hasPermission("view-geofences-list")}>
        <PageHeader
          icon={MapPin}
          title="Cercas Virtuais"
          description="Configure as áreas permitidas para registro de ponto"
        >
          <If condition={hasPermission("create-geofence")}>
            <AddBtn updateFront={setListData} />
          </If>
        </PageHeader>
        <div className="flex flex-col gap-3">
          <UnityFilter filter={unityFilter} namePlaceholder="Buscar por nome" />
          {state === "loading" ? (
            <CreateLoaderTable cols={5} lines={6} />
          ) : (
            <TableData
              dataApi={listData}
              pageActions={pageActions}
              updateFront={setListData}
            />
          )}
        </div>
      </If>
    </Main>
  );
};
